export const en = {
    'moderation-pending': 'Pending operator moderation',
    'moderation-rejected': 'Rejected by some operators'
};
